import { Component, OnInit } from '@angular/core';
import { ColorScheme, LayoutService } from '../../../../layout/service/app.layout.service';

@Component({
  selector: 'app-theme-selector',
  templateUrl: './theme-selector.component.html',
  styleUrl: './theme-selector.component.scss'
})
export class ThemeSelectorComponent implements OnInit {

  colorSchemes: { value: ColorScheme; label: string }[] = [
    { value: 'light', label: 'Light' },
    { value: 'dim',   label: 'Dim'   },
    { value: 'dark',  label: 'Dark'  },
  ];

  constructor(public layoutService: LayoutService) {}

  ngOnInit(): void {}

  get selectedScheme(): ColorScheme {
    return this.layoutService.config().colorScheme;
  }

  onSchemeChange(scheme: ColorScheme): void {
    this.layoutService.config.update(config => ({ ...config, colorScheme: scheme }));
  }
}
